var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('stripe-element-card',{ref:"elementRef",attrs:{"pk":_vm.publishableKey,"element-options":_vm.elementOptions,"hide-postal-code":true},on:{"token":_vm.tokenCreated,"element-ready":_vm.elementReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }